import Vue from 'vue';
import { magic } from '@gig/magic-sdk';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const OFFER_NAMESPACE = "OFFER_NAMESPACE";
const SET_OFFER = "SET_OFFER";
const SET_OFFERS = "SET_OFFERS";
const offerGetters = {
  getOffer(state) {
    return (offerSlug, lang) => {
      const offer = state.offers[lang] && state.offers[lang][offerSlug];
      if (!offer) {
        return null;
      }
      return offer;
    };
  },
  getOffersByAffiliate(state) {
    return (offerSlugPrefix, affiliateId, lang) => {
      const allOffers = state.offers[lang];
      if (!allOffers) {
        return [];
      }
      const offers2 = Object.values(allOffers);
      let matchedOffers = offers2.filter((offer) => offer.slug.startsWith(offerSlugPrefix) && offer.btag === affiliateId);
      if (affiliateId && matchedOffers.length === 0) {
        matchedOffers = offers2.filter((offer) => offer.slug === offerSlugPrefix);
      }
      return matchedOffers;
    };
  }
};
const offerActions = {
  fetchOffer(_0, _1) {
    return __async(this, arguments, function* ({ commit, getters }, { slug, lang }) {
      const offer = getters.getOffer(slug, lang);
      if (offer) {
        return offer;
      }
      const fetchedOffer = yield magic.methods.offers.get(lang, slug);
      commit(SET_OFFER, { offer: fetchedOffer, lang });
      return fetchedOffer;
    });
  },
  fetchAllOffers(_0, _1) {
    return __async(this, arguments, function* ({ commit }, { lang }) {
      const allOffers = yield magic.methods.offers.getAll(lang);
      if (!allOffers) {
        return null;
      }
      commit(SET_OFFERS, { allOffers, lang });
      return allOffers;
    });
  }
};
const offers = {
  namespaced: true,
  state: {
    offers: {}
  },
  getters: offerGetters,
  actions: offerActions,
  mutations: {
    [SET_OFFER](state, { lang, offer }) {
      if (!state.offers[lang]) {
        Vue.set(state.offers, lang, { [offer.slug]: offer });
        return;
      }
      Vue.set(state.offers[lang], offer.slug, offer);
    },
    [SET_OFFERS](state, { allOffers, lang }) {
      const offerDictionary = allOffers.reduce((prev, offer) => {
        prev[offer.slug] = offer;
        return prev;
      }, {});
      Vue.set(state.offers, lang, offerDictionary);
    }
  }
};

export { OFFER_NAMESPACE, offerActions, offerGetters, offers };
